import { render, staticRenderFns } from "./changeCard.vue?vue&type=template&id=48dd165b&scoped=true"
import script from "./changeCard.vue?vue&type=script&lang=js"
export * from "./changeCard.vue?vue&type=script&lang=js"
import style0 from "./changeCard.vue?vue&type=style&index=0&id=48dd165b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd165b",
  null
  
)

export default component.exports